import { List, Map, fromJS } from 'immutable';
import { finish as updateCustomer } from './update';

export function request(state, { id }) {
    id = parseInt(id, 10);

    let selfExclusion = state.get('self-exclusion') || Map();
    let user = selfExclusion.get(id) || Map();

    user = user
        .set('state', 'IN_PROGRESS')
        .set('errors', void 0);

    return state.set(
        'self-exclusion', selfExclusion.set(id, user)
    );
}

export function error(state, { id, errors }) {
    id = parseInt(id, 10);

    let selfExclusion = state.get('self-exclusion') || Map();
    let user = selfExclusion.get(id) || Map();

    user = user
        .set('state', 'ERROR')
        .set('errors', fromJS(errors));

    return state.set(
        'self-exclusion', selfExclusion.set(id, user)
    );
}

export function finish(state, { id, customer }) {
    id = parseInt(id, 10);

    let selfExclusionEl = state.get('self-exclusion') || Map();
    let userEl = selfExclusionEl.get(id) || Map();

    userEl = userEl
            .set('state', 'FINISHED')
            .set('errors', void 0);

    state = state.set('self-exclusion', selfExclusionEl.set(id, userEl));

    return customer ? updateCustomer(state, { id, customer }) : state;
}

export function clear(state) {
    return state.set('self-exclusion', Map());
}
